<!-- Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. -->

import {Layout} from '@react-spectrum/docs';
export default Layout;

import docs from 'docs:@react-spectrum/well';
import {HeaderInfo, PropTable} from '@react-spectrum/docs';
import packageData from '../package.json';

```jsx import
import {Heading} from '@react-spectrum/typography';
import {Well} from '@react-spectrum/well';
```

---
category: Content
---

# Well

<p>{docs.exports.Well.description}</p>

<HeaderInfo
  packageData={packageData}
  componentNames={['Well']} />

## Example

```tsx example
<Well>Better a little which is well done, than a great deal imperfectly.</Well>
```

## Content

Wells accept any renderable children.

```tsx example
<Well>Well, well, well</Well>

```

### Internationalization

In order to internationalize a well, a localized string should be passed to the `children` prop.

### Accessibility

By default, the visual separation of a Well is not conveyed to assistive technologies. As such it should be used where this separation makes no difference in understanding the content.

However, if the Well does convey semantic meaning then a role must be specified and, if appropriate, labeled using either aria-label or aria-labelledby.

```tsx example
<Well role="region" aria-labelledby="wellLabel">
  <h3 id="wellLabel">Shipping Address</h3>
  <p>601 Townsend Street<br /> San Francisco, CA 94103</p>
</Well>
```

## Props

<PropTable component={docs.exports.Well} links={docs.links} />
